import { FieldRow } from "./styles";

type Props = {
  password: string;
};

export default function VisitDigitalKeyPassword({ password }: Props) {
  return (
    <FieldRow>
      <b>Senha da chave digital: </b>
      {password}
    </FieldRow>
  );
}
